<script setup lang="ts">
import HeroSection from '@/components/hero-section/HeroSection.component.vue'
import Features from '@/components/feature-section/FeatureSection.component.vue'
import SecondaryFeatures from '@/components/feature-section-secondary/FeatureSectionSecondary.component.vue'
import PricingSection from '@/components/pricing-section/PricingSection.component.vue'
//import { getLcidFromRouteParams } from '@/pages-hooks/route-params'
import { getPageDataByRoute } from '@/pages-hooks'
const { params } = useRoute()
//const lcid = getLcidFromRouteParams(params)

const { lcid } = <any>useAttrs()
const { hero: heroData } = <any>useAttrs().pageData

// get also /features data as we  need it on the home page:
const { primaryFeatures, secondaryFeatures } = <any>getPageDataByRoute('/features', params)
// get also /pricing data as we  need it on the home page:
const pricingData = <any>getPageDataByRoute('/pricing', params)

const refCurrentScrollY = ref(0)

onMounted(() => {
  if (import.meta.client && document) {
    window.addEventListener('scroll', () => (refCurrentScrollY.value = window.scrollY))
  }
})
</script>

<template>
  <main class="flex flex-col">
    <HeroSection :lcid="lcid" :currentScrollY="refCurrentScrollY" :heroData="heroData" />
    <Features :lcid="lcid" :features="primaryFeatures" />
    <SecondaryFeatures :features="secondaryFeatures" />
    <PricingSection :lcid="lcid" :pricingData="pricingData" />
  </main>
</template>
